function getImageModalElements() {
    const modal = document.getElementById('imageModal');
    const image = document.getElementById('modalImage');
    const closeButton = document.getElementById('closeModal');

    if (!modal || !image) return null;

    return { modal, image, closeButton };
}

function openImageModal(imgSrc) {
    const elements = getImageModalElements();

    if (!elements || !imgSrc) return;

    elements.image.src = imgSrc;
    elements.modal.style.display = 'flex';
}

function closeImageModal() {
    const elements = getImageModalElements();

    if (!elements) return;

    elements.modal.style.display = 'none';
}

let imageModalCloseHandlingInitialized = false;

function addImageModalCloseHandling() {
    if (imageModalCloseHandlingInitialized) return;

    const elements = getImageModalElements();

    if (!elements) return;

    elements.closeButton?.addEventListener('click', closeImageModal);

    elements.modal.addEventListener('click', function (event) {
        if (event.target === elements.modal) {
            closeImageModal();
        }
    });

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
            closeImageModal();
        }
    });

    imageModalCloseHandlingInitialized = true;
}

export function addSwiper() {
    const swiperContainers = document.querySelectorAll('.swiper-container');

    addImageModalCloseHandling();

    if (!swiperContainers.length || typeof Swiper === 'undefined') return;

    new Swiper('.swiper-container', {
        // Optional parameters
        direction: 'horizontal',
        loop: true,


        // autoHeight: true,

        // If we need pagination
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },

        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },

        // And if we need scrollbar
        scrollbar: {
            el: '.swiper-scrollbar',
        },

    });
    // Select all swiper containers
    // click on slider image:
    swiperContainers.forEach(function (container) {
        container.addEventListener('click', function (event) {
            if (event.target.closest('.link-to')) {
                return; // Exit the function early if true
            }
            if (event.target.closest('.no-lightbox')) {
                return; // Exit the function early if true
            }
            if (event.target.closest('.use-lightbox')) {
                const clickedSlide = event.target.closest('.swiper-slide');
                const imgSrc = clickedSlide?.querySelector('img')?.src;
                openImageModal(imgSrc);
            }
        });
    });



}

export function addImageLinkHandling() {
    // Select all image links
    document.querySelectorAll('.image-link').forEach(function (container) {
        container.addEventListener('click', function (event) {
            event.preventDefault();
            const clickedImage = container.querySelector('img');
            openImageModal(clickedImage?.src);
        });
    });
}
